export enum AdornmentType {
  PREFIX = 'PREFIX',
  SUFFIX = 'SUFFIX',
}
